import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import cn from 'classnames';

import styles from './styles.module.scss';

const SessionExpired = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const timeoutRef = useRef();

  const isExpiredSession = searchParams.get('session_expired');

  useEffect(() => {
    const MEMO_DURATION = 15000;
    if (isExpiredSession && !timeoutRef.current) {
      timeoutRef.current = setTimeout(() => {
        setSearchParams({});
      }, MEMO_DURATION);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpiredSession]);

  if (!isExpiredSession) {
    return null;
  }

  return (
    <p className={cn('text-error', styles.error)}>
      Your session expired. Please, log in again.
    </p>
  );
};

export default SessionExpired;
